/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';

export default class DiscordIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked hasStaleIntegration = false;
  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('discord-channel')) {
      return;
    }

    try {
      let response = await fetch(`/ember/discord/integrations?app_id=${this.session.workspace.id}`);

      if (response.ok) {
        await response.json();
        //We will need to add proper stale check here later (or remove this)
        this.hasStaleIntegration = false;
      } else {
        console.error('Error loading Discord integration:', response.statusText);
        this.hasStaleIntegration = false;
      }
    } catch (error) {
      console.error('Error loading Discord integration:', error);
      this.hasStaleIntegration = false;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'discord-integration-service': DiscordIntegrationService;
  }
}
